import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import type {
  TDeleteAiConversationRequestSchema,
  TDeleteAiConversationResponseSchema,
} from "./deleteAiConversation.schema";

type TSuccess = ZealApiSuccessResponse<TDeleteAiConversationResponseSchema>;

export const deleteAiConversation = (axios: IAxiosInstance) => {
  return async (
    params: TDeleteAiConversationRequestSchema
  ): Promise<TDeleteAiConversationResponseSchema> => {
    try {
      const encodedId = encodeURIComponent(params.conversationId);
      const response = await axios.noRetry.delete<TSuccess>(
        `/api/ai/conversations/${encodedId}`,
        {
          params: {
            companyId: params.companyId,
            userId: params.userId,
          },
        }
      );
      const body = response.data;
      if (body?.success === true) {
        return body.data;
      }
      throw new ZealClientError(response);
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
